import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    URL_CHECKOUT_BOPIS,
    URL_CHECKOUT_SHIPPING,
    URL_CHECKOUT_PAYMENT,
} from 'yoda-checkout-components/lib/common/Constants';
import ServiceErrorMessage from 'yoda-checkout-components/lib/components/ServiceErrorMessage/ServiceErrorMessage';
import { PAYMENT } from 'yoda-checkout-components/lib/common/LabelConstants';
import * as checkoutAnalyticsActions from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as PlaceOrderActions from 'yoda-checkout-components/lib/actions/PlaceOrderActions';
import * as checkoutPageActions from '../../../../../actions/CheckoutPageActions';
import CheckoutAccordion from '../../../Checkout/components/CheckoutAccordion/CheckoutAccordion';
import OrderInfoAction from '../../../../../actions/OrderInfoAction';
import CheckoutAccordionSection from '../../../Checkout/components/CheckoutAccordion/CheckoutAccordionSection';

export function ReviewAccordionWrapper(props) {
    const accordionConfig = {
        toExpandAll: true,
        isAutoCollapsible: false,
        isEdit: true,
    };

    function editCallback(actionValue) {
        if (actionValue.toLowerCase() === 'shipping') {
            const payload = {
                isPreLoadCall: false,
            };
            props.actions.getOrderInfo(payload);
        }
        if (
            props.payment &&
            props.payment.promoFinancingData &&
            props.payment.promoFinancingData.options &&
            props.payment.promoFinancingData.options.length > 0
        ) {
            props.actions.resetPromoFinancingData();
        }
        // Action trrigered to update all sections are valid but will be shown in ui based on exists criteria
        /* istanbul ignore next */
        let path = '';
        if (actionValue === 'Same Day Pickup') {
            path = URL_CHECKOUT_BOPIS;
        } else if (actionValue.toLowerCase() === 'shipping') {
            path = URL_CHECKOUT_SHIPPING;
        } else {
            path = URL_CHECKOUT_PAYMENT;
        }
        props.actions.initNewCheckoutSectionsClientSideActions(path, true);
    }

    return (
        <CheckoutAccordion
            toExpandAll={accordionConfig.toExpandAll}
            automationId="review-page-accordion"
            isAutoCollapsible={accordionConfig.isAutoCollapsible}
        >
            {props.accordionList
                ? props.accordionList.map((item, index) => {
                      const accordianSection = (
                          <CheckoutAccordionSection
                              index={index + 1}
                              title={item.title}
                              editCallback={editCallback}
                              isEdit={accordionConfig.isEdit}
                          >
                              {PAYMENT === item.title && (
                                  <ServiceErrorMessage
                                      sectionName="PAYMENT"
                                      componentName="REVIEW_PAYMENT_SECTION"
                                  />
                              )}
                              {item.container}
                          </CheckoutAccordionSection>
                      );
                      return accordianSection;
                  })
                : ''}
        </CheckoutAccordion>
    );
}

ReviewAccordionWrapper.propTypes = {
    accordionList: PropTypes.arrayOf(PropTypes.object),
    actions: PropTypes.object,
    payment: PropTypes.object,
};

ReviewAccordionWrapper.defaultProps = {
    accordionList: [],
    actions: {},
    payment: {},
};

const mapStateToProps = (state) => ({
    payment: state.payment,
});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...checkoutAnalyticsActions,
            ...PlaceOrderActions,
            ...OrderInfoAction,
            ...checkoutPageActions,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewAccordionWrapper);
